import type { MessageDetail } from '@dte/otw-azure-functions/src/common/interfaces/api/messageDetail/MessageDetail';
import type { PropsWithChildren, ReactNode } from 'react';
import { useLookupValueFromConfigValueContext } from '../../../../../../../contexts/ConfigValue/Wrapper';

export interface MessageVariantWrapperProps extends PropsWithChildren {
	variantId: string;
}
function MessageVariantWrapperContent({ variantId, children }: MessageVariantWrapperProps): ReactNode {
	const variant = useLookupValueFromConfigValueContext<MessageDetail>(variantId);
	if (!variant || variant.disabled) {
		return null;
	}

	return children;
}

export function MessageVariantWrapper({ variantId, children }: MessageVariantWrapperProps): ReactNode {
	return <MessageVariantWrapperContent variantId={variantId}>{children}</MessageVariantWrapperContent>;
}
